export class DomUtil {

  isKeypressNumeric(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {

      return false;
    }

    return true;
  }

  static getTarget(event: any): any {
    const target = event.target || event.srcElement || event.currentTarget;
    return target;
  }

  focuRecursivo(idElement: string, tentantiva?: number): void {
    tentantiva = tentantiva ? tentantiva : 0;

    if ( tentantiva > 5 ) {
      return;
    }

    try {
      const dom = document.getElementById(idElement);
      if ( dom ) {
        dom.focus();
        return;
      }

      setTimeout(() => {
        this.focuRecursivo(idElement, ++tentantiva);
      }, 250);
    }
    catch(e) { console.error(e); }
  }

  public isElementVisible(el) {
    try {
      if (!el) {
        return false;
      }

      var rect = el.getBoundingClientRect();

      if (rect.top == 0 && rect.left == 0 && rect.bottom == 0 && rect.right == 0 ) {
        return false;
      }

      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }
    catch(e) {
      console.error(e);
    }

    return false;
  }

}
